import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { LoadingSpinner } from '~components/Order/ordersDispatchStyledComponents';

interface PreparingSettlementsToasterProps {
  onClose: () => void;
}

export function PreparingSettlementsToaster({
  onClose,
}: PreparingSettlementsToasterProps) {
  return (
    <Box
      sx={(theme) => ({
        alignItems: 'center',
        bgcolor: theme.semantic.surfaceToast,
        boxShadow: `inset 0 0 0 1px ${theme.semantic.borderToast}`,
        display: 'flex',
        gap: 2,
        p: 2,
      })}
    >
      <LoadingSpinner isVisible sx={{ flex: 0 }} />

      <Typography
        sx={(theme) => ({
          color: theme.semantic.textOnToast,
          fontSize: '12px',
          fontWeight: 600,
          flex: 1,
        })}
      >
        {t(
          'approvals.driver_pay.settlements.bulk_create_settlement.preparing_settlements',
        )}
      </Typography>

      <IconButton
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          onClose();
        }}
      >
        <Close
          sx={(theme) => ({ fontSize: '13px', color: theme.semantic.textOnToast })}
        />
      </IconButton>
    </Box>
  );
}
